<template>
  <div class="">
    <v-card :loading="(!fetched && id) || savingInProgress" class="ma-0 pb-0 pa-0" elevation="0">
      <v-card-text :class="{'pa-0':dense, 'ma-0':dense}">
        <v-autocomplete
          id="customerFindFormAutocomplete"
          ref="customerFindFormAutocomplete"
          class="ma-0"
          outlined
          @change="select"
          :items="findedCustomers"
          :loading="isFindingCustomers"
          clearable
          hide-no-data
          hide-details
          :item-text="autocompleteItemText"
          :search-input.sync="findCustomerString"
          :label="$t('viewCustomers.search_exist_customer')"
          :placeholder="$t('common.start_typing_to_search')"
          prepend-inner-icon="mdi-database-search"
          return-object
        ></v-autocomplete>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import CustomerGarage from "@/components/customer/CustomerGarage";
import { mapFields } from "vuex-map-fields";
import CommonMixin from "@/mixins/common";

export default {
  name: "customerFindForm",
  mixins: [CommonMixin],
  props: {
    visible: Boolean,
    dense: { // убираем отступ у card-text (pa-0, ma-0)
      type: Boolean,
      default: false,
    },
  },
  components: {
    CustomerGarage,
  },
  data: () => ({
    id: null,
  }),
  mounted() {
    this.focusCustomerFindFormAutocomplete();
  },
  updated() {
    this.focusCustomerFindFormAutocomplete();
  },
  computed: {
    ...mapFields("customers", [
      "customer",
      "fetched",
      "isFindingCustomers",
      "findCustomerString",
      "findedCustomers",
      "savingInProgress",
      "customerFormTabsId",
    ]),
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.focusCustomerFindFormAutocomplete();
      }
    },
    findCustomerString() {
      if (!this.isFindingOrders) this.$store.dispatch("customers/find");
    },
  },
  methods: {
    focusCustomerFindFormAutocomplete() {
      this.$nextTick(function () {
        document.getElementById("customerFindFormAutocomplete").focus();
      });
    },
    select(data) {
      this.$emit("select", data);
      this.findedCustomers = [];
      this.findCustomerString = "";
    },
    autocompleteItemText(item) {
      let car = "";
      let vin = "";
      car =
        item.cars &&
        item.cars.filter((it) => it.vin === this.findCustomerString);
      if (car && car[0]) {
        vin = "/" + car[0]["vin"] + " " + car[0]["name"] + "/";
      }
      return `[#${item.human_number}] ${vin} ${item.last_name} ${
        item.first_name
      } ${item.patronymic ? item.patronymic : ""} (${item.phone}) [${this.$moment(item.created_at).format("DD.MM.YYYY HH:mm")}]`;

    },
  },
};
</script>
